<template>
  <i-box>
    <span slot="title">
      <h3>Engaged Audience Profiles</h3>
      <div class="clearfix"></div>
    </span>
    <span slot="heading">Statistics calculated from profiles that exist</span>

    <span slot="content">
      <div v-loading="loading" element-loading-text="Loading Audience Profiles...">
        <div v-if="hasData">
          <el-row :gutter="20">
            <el-col :span="8">
              <pie-chart :height="250" :data="data.age" :options="options" />
            </el-col>
            <el-col :span="7" class="chart-box">
              <table-chart label="Language" :data="data.language" />
            </el-col>
            <el-col :span="8" class="chart-box">
              <table-chart label="Location" :data="data.location" />
            </el-col>
          </el-row>

          <div class="spacer"></div>

          <el-row :gutter="20">
            <el-col :span="8">
              <pie-chart :height="250" :data="data.gender" :options="options" />
            </el-col>
            <el-col :span="8" class="chart-box">
              <table-chart label="Channels" :data="data.numberOfChannels" />
            </el-col>
          </el-row>
        </div>
        <div v-else style="height: 525px">
          <small class="graph-empty">No Data Loaded</small>
        </div>
      </div>
    </span>
  </i-box>
</template>

<script>
import IBox from '@/components/common/IBox';
import PieChart from '@/components/charts/LabelledPieChart';
import TableChart from '@/components/profiles/charts/ProfileTableChart';

export default {
  name: 'AudienceProfileChart',
  components: {
    IBox,
    PieChart,
    TableChart,
  },
  data: () => ({
    options: {
      showTooltips: false,
      plugins: {
        datalabels: {
          display: 'auto',
          color: '#fff',
          formatter: (value, ctx) => {
            if (value < 10) return '';
            return `${ctx.chart.data.labels[ctx.dataIndex]} - ${value}%`;
          },
        },
      },
    },
  }),
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasData() {
      if (!this.data) return false;
      return Object.values(this.data).some(val => Array.isArray(val) && val.length > 0);
    },
  },
};
</script>

<style scoped>
.chart-box {
  padding: 14px;
}

.graph-empty {
  display: block;
  padding: 220px 0;
  text-align: center;
}

.spacer {
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// AudienceProfileChart.vue?6390e06c